<div class="tree-select">
    <tree-root #tree [(state)]="state" [nodes]="updatedNodes" [options]="options" (activate)="selectedNodeChanged.emit($event)" (deactivate)="selectedNodeChanged.emit($event)">
        <ng-template #treeNodeTemplate let-node let-index="index">
            <span class="expand-collapse-toggle" (click)="onToggle(node, $event)">
                @if (node?.hasChildren) {
                    @if (node.isExpanded) {
                        <kui-icon name="chevron-down"></kui-icon>
                    } @else {
                        <kui-icon name="chevron-right"></kui-icon>
                    }
                }
            </span>

            @if (node.data.icon) {
                <kui-icon [size]="1" [name]="node.data.icon" [fixedWidth]="true" class="mr-2"></kui-icon>
            }
            <span>{{ node.data.name }}</span>
        </ng-template>

        <ng-template #loadingTemplate>
            <kui-loader size="small"></kui-loader>
        </ng-template>
    </tree-root>
</div>
